var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterbeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "38px",
    viewBox: "0 0 104 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE9Bicon/railcar/centerbeams2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-27",
    fill: "#4F7CB4",
    cx: 94,
    cy: 34,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-28",
    fill: "#4F7CB4",
    cx: 83,
    cy: 34,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-29",
    fill: "#4F7CB4",
    cx: 9,
    cy: 34,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-30",
    fill: "#4F7CB4",
    cx: 21,
    cy: 34,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,0 L104,29.93 L104.142173,30.1495074 L104,30.241 L104,32 L0,32 L0,0 L104,0 Z M2,4.346 L2,30 L18.66,30 L2,4.346 Z M22,2.806 L22,30 L39.66,30 L22,2.806 Z M84,2.806 L84,30 L101.66,30 L84,2.806 Z M43,4.346 L43,30 L59.66,30 L43,4.346 Z M63,2.806 L63,30 L80.66,30 L63,2.806 Z M20,2 L2.861,2 L20,28.391 L20,2 Z M41,2 L23.861,2 L41,28.391 L41,2 Z M61,2 L43.861,2 L61,28.391 L61,2 Z M82,2 L64.861,2 L82,28.391 L82,2 Z M102,2 L85.861,2 L102,26.851 L102,2 Z",
    id: "Combined-Shape",
    fill: "#4F7CB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterbeams);
export default __webpack_public_path__ + "static/media/centerbeams.6a1f790f22fcaf62a3df2cf6971d195d.svg";
export { ForwardRef as ReactComponent };